import React from "react";
import Lottie from "react-lottie";
import animationData from "../../assets/Animation/cat.json";
import "./Confirmation.scss";
import { useTranslation } from "react-i18next";

const ConfirmationPage = () => {
  const { t } = useTranslation();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      className="confirmation-page"
      style={{ backgroundImage: 'url("/Images/conf.jpg")' }}
    >
      <h1>{t("confirmation.title")}</h1>
      <p>{t("confirmation.message")}</p>
      <Lottie options={defaultOptions} height={300} width={300} />
    </div>
  );
};

export default ConfirmationPage;
